import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=2ec396ee&scoped=true&"
import script from "./NewHome.vue?vue&type=script&lang=js&"
export * from "./NewHome.vue?vue&type=script&lang=js&"
import style0 from "./NewHome.vue?vue&type=style&index=0&id=2ec396ee&lang=scss&scoped=true&"
import style1 from "./NewHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec396ee",
  null
  
)

export default component.exports